import CContractBase, { ETypes } from '@/contracts/base';
import { parseEther } from 'ethers/lib/utils';
import {
  ICancelProposalPrams,
  ICreateProposalParams,
  IVoteProposalParams,
} from '@/contracts/alphaGovernor/types';
import { ethers } from 'ethers';

class CAlphaGovernor extends CContractBase {
  public createProposal = async (params: ICreateProposalParams) => {
    const {
      governorAddress,
      passTokenAddress,
      treasuryAddress,
      circleOwnerAddress,
      amount,
      description,
    } = params;

    console.log('createProposal', params);

    try {
      const akg = this.contract.getAlphaGovernorContract(governorAddress);
      const ptt = this.contract.getPassTokenContract(passTokenAddress);

      await this.estimateTCGasFee({ type: ETypes.issue });

      const tx = await akg
        .connect(this.wallet)
        .propose(
          [treasuryAddress],
          [parseEther('0')],
          [
            ptt.interface.encodeFunctionData('paymentByAmount', [
              passTokenAddress,
              parseEther(amount),
              circleOwnerAddress,
            ]),
          ],
          description
        );

      await tx.wait();
      await this.tradeAPI.scanTrxAlpha({ tx_hash: tx.hash });

      return tx;
    } catch (e) {
      throw e;
    }
  };

  public voteProposal = async (params: IVoteProposalParams) => {
    const { governorAddress, proposalId, value } = params;

    console.log('voteProposal', params);

    try {
      const akg = this.contract.getAlphaGovernorContract(governorAddress);

      await this.estimateTCGasFee({ type: ETypes.issue });

      const tx = await akg.connect(this.wallet).castVote(proposalId, value);

      await tx.wait();
      await this.tradeAPI.scanTrxAlpha({ tx_hash: tx.hash });

      return tx;
    } catch (e) {
      throw e;
    }
  };

  public creatorCancelProposal = async (params: ICancelProposalPrams) => {
    const { governorAddress, description } = params;

    const descriptionHash = ethers.utils.keccak256(
      ethers.utils.toUtf8Bytes(description)
    );
    const targets = JSON.parse(params.targets);
    const values = JSON.parse(params.values);
    const calldatas = JSON.parse(params.calldatas);

    try {
      const akg = this.contract.getAlphaGovernorContract(governorAddress);

      await this.estimateTCGasFee({ type: ETypes.issue });

      const tx = await akg
        .connect(this.wallet)
        .creatorCancel(targets, values, calldatas, descriptionHash);

      await tx.wait();
      await this.tradeAPI.scanTrxAlpha({ tx_hash: tx.hash });

      return tx;
    } catch (e) {
      throw e;
    }
  };

  public getCreateProposalData = async (
    passTokenAddress: string,
    data: string
  ) => {
    const ptt = this.contract.getPassTokenContract(passTokenAddress);

    try {
      return ptt.interface.decodeFunctionData('paymentByAmount', data);
    } catch (e) {
      throw e;
    }
  };
}

export default CAlphaGovernor;
